import { BeckyModelFactory } from '../../types/becky'

export const typedModelFactory = <Model, ExtendFunctionLibrary extends Record<string, Function> = {}>(
	modelFactory: any
): BeckyModelFactory<Model, ExtendFunctionLibrary> => {
	return modelFactory
}
